import { useToast } from "@/hooks/useToast"
import { Toast, ToastClose, ToastDescription, ToastTitle, ToastViewport } from "@/components/ui/toast"
import { CheckCircle, AlertCircle, AlertTriangle, Info } from "lucide-react"

export function Toaster() {
  const { toasts } = useToast()

  const getIcon = (variant) => {
    switch (variant) {
      case 'success': return <CheckCircle className="h-5 w-5 text-white" />
      case 'destructive': return <AlertCircle className="h-5 w-5 text-white" />
      case 'warning': return <AlertTriangle className="h-5 w-5 text-warning" />
      default: return <Info className="h-5 w-5 text-primary" />
    }
  }

  return (
    <ToastViewport>
      {toasts.map(function ({ id, title, description, variant, action, ...props }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-start gap-3">
              {getIcon(variant)}
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
    </ToastViewport>
  )
}
